import React from 'react'
import { Box, Typography } from '@mui/material'
import LuckyDrawTable from './Table'
import Toolbar from './Toolbar'

const LuckyDraw = () => (
  <Box
    mb={8}
    textAlign='center'
    boxShadow={1}
    style={{ color: '#464646', background: 'whitesmoke' }}
  >
    <Box pt={6} pb={4}>
      <Typography variant='h2' gutterBottom={true}>
        Dealer
      </Typography>
      <Typography variant='h1' fontWeight={900} fontSize={36}>
        Lucky Draw
      </Typography>
    </Box>

    <Toolbar></Toolbar>
    <LuckyDrawTable></LuckyDrawTable>
  </Box>
)

export default LuckyDraw
